module.exports = __webpack_public_path__ + "img/default-avator.0c0120f1.png";